import isUserDeveloper from "@Middleware/isUserDeveloper";
import isUserLoggedIn from "@Middleware/isUserLoggedIn";

const AppKiosk = () => import(/* webpackChunkName: 'kiosk' */ "@Views/kiosk/Index.vue");
const AppKioskAccessInvitaions = () => import(/* webpackChunkName: 'kiosk' */ "@Views/kiosk/AccessInvitations/Index.vue");
const AppKioskAnnouncements = () => import(/* webpackChunkName: 'kiosk' */ "@Views/kiosk/Announcements.vue");
const AppKioskUsers = () => import(/* webpackChunkName: 'kiosk' */ "@Views/kiosk/Users.vue");
const AppKioskProfile = () => import(/* webpackChunkName: 'kiosk' */ "@Views/kiosk/Profile.vue");
const AppKioskAliases = () => import(/* webpackChunkName: 'kiosk' */ "@Views/kiosk/Aliases.vue");
const AppKioskAlias = () => import(/* webpackChunkName: 'kiosk' */ "@Views/kiosk/Alias.vue");
const AppKioskLongUrls = () => import(/* webpackChunkName: 'kiosk' */ "@Views/kiosk/LongURLs/Index.vue");
const AppKioskSystemStats = () => import(/* webpackChunkName: 'kiosk' */ "@Views/kiosk/SystemStats.vue");
const AppKioskTinyurlStats = () => import(/* webpackChunkName: 'kiosk' */ "@Views/kiosk/Stats.vue");
const AppKioskPasswordDictionary = () => import(/* webpackChunkName: 'kiosk' */ "@Views/kiosk/PasswordDictionary/Index.vue");
const AppKioskIPs = () => import(/* webpackChunkName: 'kiosk' */ "@Views/kiosk/IPs/Index.vue");
const AppKioskCloudflareZones = () => import(/* webpackChunkName: 'kiosk' */ "@Views/kiosk/CloudflareZones/Index.vue");
const AppKioskBannedDomains = () => import(/* webpackChunkName: 'kiosk' */ "@Views/kiosk/BannedDomains/Index.vue");
const AppKioskDomains = () => import(/* webpackChunkName: 'kiosk' */ "@Views/kiosk/Domains/Index.vue");
const AppKioskDomain = () => import(/* webpackChunkName: 'kiosk' */ "@Views/kiosk/Domains/Domain.vue");
const AppKioskSurveys = () => import(/* webpackChunkName: 'kiosk' */ "@Views/kiosk/Surveys/Index.vue");
const AppKioskSurvey = () => import(/* webpackChunkName: 'kiosk' */ "@Views/kiosk/Surveys/Survey.vue");
const AppKioskTldOverprice = () => import(/* webpackChunkName: 'kiosk' */ "@Views/kiosk/TLD/Index.vue");
const AppKioskOverages = () => import(/* webpackChunkName: 'kiosk' */ "@Views/kiosk/Overages/Index.vue");

export default {
  path: "/app/kiosk",
  name: "kiosk",
  component: AppKiosk,
  meta: {
    middleware: [isUserLoggedIn, isUserDeveloper],
  },
  redirect: {
    name: "kiosk.users",
  },
  children: [
    {
      path: "access-invitations",
      name: "kiosk.accessInvitations",
      components: {
        main: AppKioskAccessInvitaions,
      },
      meta: {
        middleware: [isUserLoggedIn, isUserDeveloper],
      },
    },
    {
      path: "announcements",
      name: "kiosk.announcements",
      components: {
        main: AppKioskAnnouncements,
      },
      meta: {
        middleware: [isUserLoggedIn, isUserDeveloper],
      },
    },
    {
      path: "users",
      name: "kiosk.users",
      components: {
        main: AppKioskUsers,
      },
      meta: {
        middleware: [isUserLoggedIn, isUserDeveloper],
      },
    },
    {
      path: "user/:userId",
      name: "kiosk.user",
      components: {
        main: AppKioskProfile,
      },
      props: {
        main: true,
      },
      meta: {
        middleware: [isUserLoggedIn, isUserDeveloper],
      },
    },
    {
      path: "aliases",
      name: "kiosk.aliases",
      components: {
        main: AppKioskAliases,
      },
      meta: {
        middleware: [isUserLoggedIn, isUserDeveloper],
      },
    },
    {
      path: "alias/:domain/:alias",
      name: "kiosk.alias",
      components: {
        main: AppKioskAlias,
      },
      props: {
        main: true,
      },
      meta: {
        middleware: [isUserLoggedIn, isUserDeveloper],
      },
    },
    {
      path: "long-urls",
      name: "kiosk.longUrls",
      components: {
        main: AppKioskLongUrls,
      },
      meta: {
        middleware: [isUserLoggedIn, isUserDeveloper],
      },
    },
    {
      path: "stats/system/:domain?",
      name: "kiosk.systemStats",
      components: {
        main: AppKioskSystemStats,
      },
      props: {
        main: true,
      },
      meta: {
        middleware: [isUserLoggedIn, isUserDeveloper],
      },
    },
    {
      path: "stats/tinyurl",
      name: "kiosk.tinyurlStats",
      components: {
        main: AppKioskTinyurlStats,
      },
      meta: {
        middleware: [isUserLoggedIn, isUserDeveloper],
      },
    },
    {
      path: "ips",
      name: "kiosk.ips",
      components: {
        main: AppKioskIPs,
      },
      meta: {
        middleware: [isUserLoggedIn, isUserDeveloper],
      },
    },
    {
      path: "password_dictionary",
      name: "kiosk.password_dictionary",
      components: {
        main: AppKioskPasswordDictionary,
      },
      meta: {
        middleware: [isUserDeveloper, isUserDeveloper],
      },
    },
    {
      path: "cloudflare/zones",
      name: "kiosk.cloudflareZones",
      components: {
        main: AppKioskCloudflareZones,
      },
      meta: {
        middleware: [isUserLoggedIn, isUserDeveloper],
      },
    },
    {
      path: "surveys",
      name: "kiosk.surveys",
      components: {
        main: AppKioskSurveys,
      },
      meta: {
        middleware: [isUserLoggedIn, isUserDeveloper],
      },
    },
    {
      path: "surveys/:survey",
      name: "kiosk.survey",
      components: {
        main: AppKioskSurvey,
      },
      props: {
        main: true,
      },
      meta: {
        middleware: [isUserLoggedIn, isUserDeveloper],
      },
    },
    {
      path: "domains",
      name: "kiosk.domains",
      components: {
        main: AppKioskDomains,
      },
      meta: {
        middleware: [isUserLoggedIn, isUserDeveloper],
      },
    },
    {
      path: "domain/:domain",
      name: "kiosk.domain",
      components: {
        main: AppKioskDomain,
      },
      props: {
        main: true,
      },
      meta: {
        middleware: [isUserLoggedIn, isUserDeveloper],
      },
    },
    {
      path: "banned_domains",
      name: "kiosk.banned_domains",
      components: {
        main: AppKioskBannedDomains,
      },
      meta: {
        middleware: [isUserLoggedIn, isUserDeveloper],
      },
    },
    {
      path: "tld_overprice",
      name: "kiosk.tld_overprice",
      components: {
        main: AppKioskTldOverprice,
      },
      meta: {
        middleware: [isUserLoggedIn, isUserDeveloper],
      },
    },
    {
      path: "overages",
      name: "kiosk.overages",
      components: {
        main: AppKioskOverages,
      },
      meta: {
        middleware: [isUserLoggedIn, isUserDeveloper],
      },
    },
  ],
};
